import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  field_stores_of_levels: any;
  field_level_updated_at: any;
  field_level_created_at: any;
  field_store_location_code: any;
  field_location_airports: any;
  field_location_level_name_zh: any;
  field_location_level_name_ms: any;
  field_location_level_name: any;
  payload: any;
  id: string;
  name: string;
  field_location_level_image: string;
  field_ranking: string;
  field_location_icon: string;
  published: boolean;
}

// edit api call
const fetchLevelDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanCMSApi.get(`/api/get-location-map-levels-data/${id}`);
  return response?.data.data;
};

const useLevelDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["levelDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchLevelDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useLevelDocumentDetails };
